__turbopack_context__.v({
  "full-page-container": "mobile-bottom-bar-module-scss-module__dGf0Ta__full-page-container",
  "is-visible": "mobile-bottom-bar-module-scss-module__dGf0Ta__is-visible",
  "wrapper": "mobile-bottom-bar-module-scss-module__dGf0Ta__wrapper",
});
